{
    "NewuserWelcomereporting": "Bienvenue à Akixi Reporting",
    "NewuserWelcometoreporting": "Bienvenue aux rapports",
    "NewuserLetsbegin": "Commençons.",
    "NewuserStartTutorial": "Tutoriel de démarrage",
    "NewuserSkiptutorial": "Sauter le tutoriel",
    "NewuserAddmodifyreport": "Ajouter\/Modifier des rapports...",
    "NewuserReportfiltering": "Filtrage des rapports...",
    "NewuserAddingfields": "Ajouter des champs...",
    "NewuserReportquickchanges": "Rapport Changements rapides...",
    "NewuserFinish": "Finition",
    "NewuserNext": "Suivant",
    "NewuserPrevious": "Précédent",
    "NAME": "LanguageNewUserTutorial"
}